import { render, staticRenderFns } from "./AuthPasswordRecoveryForm.vue?vue&type=template&id=494c636c&scoped=true&lang=pug&"
import script from "./AuthPasswordRecoveryForm.vue?vue&type=script&lang=js&"
export * from "./AuthPasswordRecoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthPasswordRecoveryForm.vue?vue&type=style&index=0&id=494c636c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c636c",
  null
  
)

export default component.exports